import React from 'react'
import bannerImage from '../../../static/banner-informativo-info-pagamento.png'
import { BannerInfoPagApp, ButtomsApp, Content } from './styles'
import ButtomGoogleApp from '../ButtomGoogleApp'
import ButtomIosApp from '../ButtomIosApp'

const BannerInfoPaymentApp = ({ image }) => {
  const bannerImageSrc = image ?? bannerImage

  return (
    <Content>
      <BannerInfoPagApp src={bannerImageSrc} alt="Banner Informativo" />
      <ButtomsApp>
        <ButtomGoogleApp />
        <ButtomIosApp />
      </ButtomsApp>
    </Content>
  )
}

export default BannerInfoPaymentApp
